import React, { useContext, useState } from 'react';
import "../index.css"; // Fichier CSS pour les styles
// import img1 from "../../assets/img1.png";
import img2 from "../../assets/img.png";
import Mask2 from '../../assets/Fr.png';
// import { getAllContents } from '../../services/content.service';
import LanguageContext from '../../context/LanguageContext';
import { useLoader } from '../../context/LoaderContext';

const WelcomeSection = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleContent = () => {
    setIsExpanded(!isExpanded);
  };

  const getShortText = (text) => {
    const maxLength = 300; // Limite de caractères
    if (!text) return '';
    return isExpanded || text.length <= maxLength
      ? text
      : text.substring(0, maxLength) + '...'; // Ajoute des "..." si le texte est coupé
  };


  const { selectedLanguage } = useContext(LanguageContext);
  // const [contents, setContents] = useState();

  const { appData } = useLoader();
  const { contents } = appData;
  // // Get contents on component mount
  // useEffect(() => {
  //   const fetchContents = async () => {
  //     try {
  //       // const savedContents = localStorage.getItem("contents");
  //       // if (savedContents) {
  //       //   setContents(JSON.parse(savedContents));
  //       // } else {
  //       // Fetch contents if not in localStorage
  //       const response = await getAllContents();
  //       setContents(response.data);
  //       //   localStorage.setItem("contents", JSON.stringify(response.data));
  //       // }
  //     } catch (error) {
  //       console.error('Failed to fetch contents:', error.message || error);
  //     }
  //   };
  //   fetchContents();
  // }, []);


  return (
    <section className="mt-4 container" style={{ paddingLeft: '0px', paddingRight: '0px' }}>
      <div className="row">
        {/* Image principale avec l'image circulaire en superposition */}
        <div className="col-lg-5 mb-3 mx-auto" style={{ paddingLeft: '0px', paddingRight: '0px' }}>
          <div className="position-relative">
            <img loading='lazy' src={contents?.data.welcoms_img.image} alt="" className="image-fluid w-100 main-img" style={{ objectFit: 'cover' }} />
            <div className="position-absolute overlay-img">
              <img loading='lazy' src={img2} alt="" className="image-fluid small-img" />
            </div>
            <div className="abso">
              <img loading='lazy' src={Mask2} alt="" style={{ width: '80%' }} />
            </div>
          </div>
        </div>

        {/* Texte et bouton Learn More */}
        <div className="col-lg-6 mb-3 mx-auto px-3">
          <div className="p-2 p-lg-4 trt">
            <h2 className="mt-3 section-title" style={{ fontSize: '36px' }}>
              {selectedLanguage === 'fr' ? (
                <div dangerouslySetInnerHTML={{
                  __html: contents?.data.home_page_welcome_title.content_fr
                }} />
              ) : (
                <div dangerouslySetInnerHTML={{
                  __html: contents?.data.home_page_welcome_title.content_en
                }} />
              )}
            </h2>
            <br />

            <div className="section-text">
  {selectedLanguage === 'fr' ? (
    <div dangerouslySetInnerHTML={{
      __html: isExpanded
        ? contents?.data.welcom_desp_2.content_fr
        : getShortText(contents?.data.welcom_desp_2.content_fr)
    }} />
  ) : (
    <div dangerouslySetInnerHTML={{
      __html: isExpanded
        ? contents?.data.welcom_desp_2.content_en
        : getShortText(contents?.data.welcom_desp_2.content_en)
    }} />
  )}
</div>


            {/* Bouton Learn More / Read Less */}
            <div className="mt-3">
              <button className="btn btn-w px-4 py-2 toggle-button" onClick={toggleContent}>
                {isExpanded
                  ? (selectedLanguage === 'fr'
                    ? contents?.data.home_page_welcome_button.content_fr
                    : contents?.data.home_page_welcome_button.content_en)
                  : (selectedLanguage === 'fr'
                    ? contents?.data.home_page_welcome_button.content_fr
                    : contents?.data.home_page_welcome_button.content_en)}

                <i className={`bi ${isExpanded ? "bi-chevron-up" : "bi-chevron-down"} ms-1`}></i>
              </button>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default WelcomeSection;
